var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Box, Divider } from 'wix-style-react';
import { InfoLine } from '../InfoSection';
export var LineItem = React.memo(function (_a) {
    var _b;
    var formatMoney = _a.formatMoney, _c = _a.isLast, isLast = _c === void 0 ? false : _c, lineItem = _a.lineItem, _d = _a.showTax, showTax = _d === void 0 ? false : _d, t = _a.t;
    var Line = function (props) { return (React.createElement(InfoLine, __assign({ clearPadding: true }, props))); };
    var renderProductInfo = function () {
        var _a, _b;
        var selectedOptions = Object.values((_b = (_a = lineItem.metadata) === null || _a === void 0 ? void 0 : _a.selectedOptions) !== null && _b !== void 0 ? _b : {});
        return (React.createElement(Box, { display: "flex", direction: "vertical" },
            React.createElement(Line, { weight: "bold" }, lineItem.name),
            selectedOptions.length ? (React.createElement(Line, null, selectedOptions.join('; '))) : null,
            lineItem.description ? (React.createElement(Line, { wordBreak: "break-word" }, lineItem.description)) : null,
            React.createElement(Line, { marginTop: "12px" }, t('price-quote.mobile-view.line-items.list.item.quantity', {
                price: formatMoney(lineItem.price),
                quantity: lineItem.quantity,
            }))));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, { direction: "horizontal" },
            React.createElement(Box, { flex: 1, marginRight: "12px" }, renderProductInfo()),
            React.createElement(Line, { weight: "bold" }, formatMoney(showTax
                ? lineItem.taxedTotal
                : ((_b = lineItem.quantity) !== null && _b !== void 0 ? _b : 1) * lineItem.price || lineItem.price))),
        showTax && lineItem.taxes.length ? (React.createElement(Line, null, lineItem.taxes
            .map(function (tax) {
            return t('price-quote.view.totals.tax-rate', {
                name: tax.name,
                rate: tax.rate,
            });
        })
            .join(' • '))) : null,
        !isLast && (React.createElement(Box, { marginTop: "20px", marginBottom: "20px" },
            React.createElement(Divider, null)))));
});
//# sourceMappingURL=LineItem.js.map